export const GET_EMPTY_IMAGE = 'GET_EMPTY_IMAGE';

export const GET_LANGUAGE = 'GET_LANGUAGE';
export const SET_LANGUAGE = 'SET_LANGUAGE';